import React from "react";
import { useDispatch } from "react-redux";

import {
  isTasksLoadingSelector,
  tasksSectionFilterSelector,
  tasksbyAllBuildingsSelector,
} from "components/pages/Tasks/model/selectors";
import { CLEAR_SECTION_TASK_FILTER } from "components/pages/Tasks/model/tasks";
import { loadMoreTasksByAllBuildings, loadTasksByAllBuildings } from "components/pages/Tasks/model/thunks";
import { tasksListFilterType } from "components/pages/Tasks/model/types";

import { useTypedSelector } from "app/store/typedUseSelector";

import { TASK_LISTS_TYPES } from "../constants";

type propsType = {
  filters: tasksListFilterType;
  type?: TASK_LISTS_TYPES;
};

export const useTasksByAllBuildingsData = ({ filters, type }: propsType) => {
  const dispatch = useDispatch();
  const tasks = useTypedSelector(tasksbyAllBuildingsSelector);
  const isTasksLoading = useTypedSelector(isTasksLoadingSelector);
  const sectionTaskFilter = useTypedSelector(tasksSectionFilterSelector);
  const invalidationKey = useTypedSelector((state) => state.tasksV2Reducer.invalidationKey);

  React.useEffect(() => {
    if (!type) return;
    dispatch(loadTasksByAllBuildings(filters, type));
  }, [type, filters, invalidationKey]);

  const tasksByType = React.useMemo(() => {
    if (!type) return null;
    return tasks?.[type] || null;
  }, [tasks, type]);

  const loadMoreTasksHandler = React.useCallback(() => {
    if (!tasksByType?.results?.length) return;
    const sectionsParam = Object.entries(sectionTaskFilter)
      .map((el) => `${el[0]}:${el[1]}`)
      .join(",");
    dispatch(
      loadMoreTasksByAllBuildings({ ...filters, building_section: sectionsParam }, type!, tasksByType?.results?.length)
    );
  }, [tasksByType?.results, filters, type, sectionTaskFilter]);

  React.useEffect(() => {
    return () => {
      dispatch({
        type: CLEAR_SECTION_TASK_FILTER,
      });
    };
  }, []);

  return {
    isTasksLoading,
    tasksByType,
    loadMoreTasksHandler,
  };
};
